import React from "react";
import Board from "./Board/Board";
import { EGKanbanContextProvider } from "./Context/EGKanbanContext";
import "../../../assets/scss/equipment-group-kanban.scss";

const EquipmentGroupKanban = props =>
    <EGKanbanContextProvider>
        <Board farmId={props.match.params.farmId} />
    </EGKanbanContextProvider>

export default EquipmentGroupKanban;